/**
* Events Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Events Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'events-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const gridWrapper = $( '#event-grid-wrapper' );
      const resultsCount = $( '#event-grid-count' );
      const layoutToggle = $( '[name="event_grid_display"]' );
      const filter = $( '#events-grid-filter' );
      const defaultLayout = localStorage.getItem( 'event_grid_display' );
      if ( defaultLayout ) {
        gridWrapper.toggleClass( 'layout-list' );
        gridWrapper.toggleClass( 'layout-cards' );
        layoutToggle.attr( 'checked', true );
      }

      layoutToggle.change( function( e ) {
        gridWrapper.toggleClass( 'layout-list' );
        gridWrapper.toggleClass( 'layout-cards' );
        if ( e.target.checked ) {
          localStorage.setItem( 'event_grid_display', e.target.checked );
        } else {
          localStorage.removeItem( 'event_grid_display' );
        }
      } );

      filter.on( 'change', function( e ) {
        // if ( e.target.checked ) {
        //   $( `[name="${e.target.name}"]` ).each( function( index, checkbox ) {
        //     if ( checkbox !== e.target ) {
        //       checkbox.checked = false;
        //     }
        //   } );
        // }
        filter.trigger( 'submit' );
      } );

      filter.on( 'submit', function( e ) {
        e.preventDefault();
        const formData = new FormData( filter.get( 0 ) );
        console.log( formData );
        let url = location.protocol + '//' + location.host + location.pathname;
        let params = new URLSearchParams( formData );
        console.log( params );
        params = params.toString();
        url = `${url}${params.length > 0 ? '?' : ''}${params}`;
        history.pushState( {}, '', url );
        $.ajax( url, {
          method: 'get',
          beforeSend: () => {
            document.querySelector( '#events-grid-filter' ).scrollIntoView( {
              behavior: 'instant',
              block: 'start',
            } );
          },
          success: ( data ) => {
            gridWrapper.html( $( data ).find( '#event-grid-wrapper' ).html() );
            resultsCount.text( $( data ).find( '#event-grid-count' ).text() );
          },
        } );
      } );

      $( '#filter-reset' ).on( 'click', function( e ) {
        filter.get( 0 ).querySelectorAll( 'input[type="checkbox"]:checked' )?.forEach( ( checkbox ) => {
          checkbox.checked = false;
        } );

        filter.trigger( 'submit' );
      } );

      const targetElement = filter.get( 0 );
      const endScrollDetector = document.querySelector( '#event-grid-scroller' );
      const filterToggle = document.querySelector( '#filter-toggle' );
      $( filterToggle ).on( 'click', function( e ) {
        e.preventDefault();
        document.querySelector( '#events-grid-filter' ).scrollIntoView( {
          behavior: 'instant',
          block: 'start',
        } );
      } );

      let targetInView = false;
      let endScrollInView = false;
      const observer = new IntersectionObserver( ( entries ) => {
        entries.forEach( ( entry ) => {
          if ( entry.target === targetElement ) {
            targetInView = entry.isIntersecting;
          } else if ( entry.target === endScrollDetector ) {
            endScrollInView = entry.isIntersecting;
          }

          if ( !targetInView && !endScrollInView ) {
            filterToggle.classList.add( 'in-view' );
          } else {
            filterToggle.classList.remove( 'in-view' );
          }
        } );
      } );

      observer.observe( targetElement );
      observer.observe( endScrollDetector );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'events-grid', COMPONENT );
} )( app );
